module.exports = __webpack_public_path__ + "img/photo-hobbie-gaming.351840f5.jpg";